type LivestreamControlsProps = {
  canStepBack: boolean;
  canStepForward: boolean;
  onStart: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLatest: () => void;
};

export function LivestreamControls({
  canStepBack,
  canStepForward,
  onStart,
  onPrev,
  onNext,
  onLatest,
}: LivestreamControlsProps) {
  return (
    <div className="livestream-controls" aria-label="Livestream playback controls">
      <button type="button" aria-label="First position" title="First position" onClick={onStart}>
        |&lt;
      </button>
      <button type="button" aria-label="Previous move" title="Previous move" disabled={!canStepBack} onClick={onPrev}>
        &lt;
      </button>
      <button type="button" aria-label="Next move" title="Next move" disabled={!canStepForward} onClick={onNext}>
        &gt;
      </button>
      <button type="button" aria-label="Latest position" title="Latest position" onClick={onLatest}>
        &gt;|
      </button>
    </div>
  );
}
